import { useState, useEffect } from 'react';
import { callApi } from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api/apiCall';

export function useReportingManagers(departmentID, JobLevelID) {
    const [employeeList, setEmployeeList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!departmentID || !JobLevelID) {
            setEmployeeList([]);
            return;
        }

        const fetchReportingManagers = async () => {
            setLoading(true);
            setError(null);

            try {
                const params = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_department_id: departmentID,
                    p_job_level_id: JobLevelID,
                };

                const data = await callApi(
                    API_ENDPOINTS.EMPLOYEE_GetReportingManagersList,
                    'POST',
                    { 'Content-Type': 'application/json' },
                    params
                );

                setEmployeeList(data?.length ? data : []);
            } catch (err) {
                setError(err.message || 'Error fetching reporting managers');
                setEmployeeList([]);
            } finally {
                setLoading(false);
            }
        };

        fetchReportingManagers();
    }, [departmentID, JobLevelID]);

    return { employeeList, loading, error };
}
